import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router';
import CardShell from 'components/CardShell';
import Popup from '../../../components/Layout/Popup';
import { composeShipmentFilterData } from './composeShipmentFilterData';
import ShipmentFilterForm from './ShipmentFilterForm';
import ShipmentFilterContext from './ShipmentFiltersContext';
import ShipmentFilterPageSummary from './ShipmentFilterPageSummary';

const ShipmentFilterPage = (props) => {
  const [summaryData, setSummaryData] = useState({});

  let popUpProperties = {
    title: '',
    description: '',
    onAccept: null,
    onDecline: null,
    open: false,
  };

  const {
    shipmentEventFilters,
    smartFilterConfiguration,
    availableShipmentStates,
    shipmentFilterExpiries,
  } = useContext(ShipmentFilterContext);
  const { match: { params: { shipmentFilterId } } } = props;

  const hasAnyShipmentEventFilters = () => shipmentEventFilters.length > 0;

  const matchedShipmentFilter = hasAnyShipmentEventFilters()
  && shipmentFilterId && shipmentEventFilters.find(key => key.id === shipmentFilterId);

  const editMode = !!shipmentFilterId && matchedShipmentFilter;

  const matchedSmartFilterConfigItem = smartFilterConfiguration
    && shipmentFilterId
    && smartFilterConfiguration.smart_filter_configuration_items
    && smartFilterConfiguration.smart_filter_configuration_items.find(item => item.shipment_filter_id === shipmentFilterId);

  const matchedShipmentFilterExpiry = shipmentFilterExpiries
    && shipmentFilterId
    && shipmentFilterExpiries.find(item => item.shipment_filter_id === shipmentFilterId);

  const expiresAfterMinutes = matchedShipmentFilterExpiry ? matchedShipmentFilterExpiry.expires_after_minutes : null;

  const backToShipmentFilterList = () => {
    props.history.push('/settings/shipment-filters');
  };

  if (!matchedShipmentFilter && !!shipmentFilterId && hasAnyShipmentEventFilters()) {
    popUpProperties = {
      title: 'Not found',
      description: `No Shipment Event Filter found for Id ${shipmentFilterId}`,
      open: true,
      onDecline: () => {
        backToShipmentFilterList();
      },
    };
  }
  return (
    <>
      <Popup {...popUpProperties} />
      <h2>Shipment event filter setup</h2>
      <div className="container__cards-with-two-columns">
        <CardShell
          noOverflow
        >
          <ShipmentFilterForm
            editMode={editMode}
            initialData={editMode
              ? composeShipmentFilterData(availableShipmentStates, matchedShipmentFilter, matchedSmartFilterConfigItem, expiresAfterMinutes)
              : null}
            setSummaryData={setSummaryData}
            flipCard={() => (editMode
              ? window.history.back()
              : backToShipmentFilterList())}
          />
        </CardShell>
        <CardShell
          noOverflow
        >
          <ShipmentFilterPageSummary summaryData={summaryData} />
        </CardShell>
      </div>
    </>
  );
};

export default withRouter(ShipmentFilterPage);
